export const VALIDATION_MAPPING: Record<string, string> = {
    // ─── ORDERS ───
    client_id: "Client Id is required",
    reference_no: "Reference Number is required",
    receiver_name: "Full name is required",
    receiver_mobile: "Receiver Phone (10–12 digits) is required",
    receiver_email: "Receiver Email is required",
    receiver_country: "Receiver Country.",
    receiver_city: "Receiver City is required",
    receiver_district: "Receiver District",
    receiver_address: "Receiver Address is required",
    receiver_national_address: "Receiver National Address is required",
    shipment_cost: "Shipment Cost is required",
    payment_type: "Payment Type (CC, COD) is required",
    cod_amount: "Cod Amount is required",
    no_of_pieces: "Number of Pieces is required",
    weight: "Weight is required",
    service: "Service is required",
    shipment_type: "Shipment Type is required",
    description: "Description Type is required",
    latitude: "Latitute is Optional",
    longitude: "Longitude is Optional",

    // ─── CLIENT / OUTSOURCE / STAFF / DRIVERS ───
    company_name: "Company Name is required",
    full_name: "Full name is required",
    name: "Full name is required",
    phone: "Phone (10–12 digits) is required",
    mobile: "Phone (10–12 digits) is required",
    mobile_no: "Phone (10–12 digits) is required",
    email: "Valid email is required",
    contact_person: "Contact Person Name required",
    contact_method: "Contact Method (Phone, Email & Whatsapp)",
    warehouse: "Warehouse is required",
    payment_term: "Payment Term (Daily, Weekly & Monthly)",
    access_type: "Access Type (LM, FM & Both)",
    client_type: "Merchant Type is required",
    short_address: "Short Address is required",
    location: "Location is required",
    vat_number: "Vat Number (15 digits) is required",
    cr_number: "CR Number (10 digits) is required",
    national_id: "National Id (10 digits) is required",
    contract_date: "Contract Date (DD-MM-YYYY) is required",
    supervisor_name: "Supervisor Name required.",
    start_date: "Start Date (DD-MM-YYYY) is required",
    iqama_number: "Iqama Number (10 digits) is required",
    iqama_no: "Iqama Number (10 digits) is required",
    vehicle_type: "Vehicle Type (Car, Van & DoKker)",
    vehicle_name: "Vehicle Name is required",
    license_number: "License Number is required",
    service_area: "Service Area is required",
    role: "Role is required",
    address: "Address required.",
    specialization: "Specialization is required",
    billing_cycle: "Billing Cycle Term (Daily, Weekly & Monthly)",
    contract_start_date: "Start Date (10-09-2025) is required",
    contract_end_date: "End Date (10-09-2025) is required", 
    primary_contact_name: "Primary Contact Name is required", 
    primary_contact_email: "Primary Contact Number is required", 
    primary_contact_number: "Primary Contact Email is required", 
    contact_types:    "Contact Method (Phone, Email & Whatsapp)",
    access:      "Access Type (LM, FM & Both)",
    roles: "Role is required",

    // ─── ALWAYS LAST ───
    reason: "Reason (System generated, not required)",
};